// Invoice entity view → InvoiceLink transform — shared between data provider wrapper and InvoiceDao.

import { calculatePricing } from '../calc.ts';
import type { InvoiceEntityView, InvoiceLink } from '@shared/types/invoice.ts';

/**
 * Enrich an invoice entity view row with computed pricing.
 * Pure function — no DB calls, no side effects.
 */
export function enrichInvoiceLink(row: InvoiceEntityView): InvoiceLink {
  return { ...row, pricing: calculatePricing(row) } as InvoiceLink;
}
